module.exports = [{
      plugin: require('../../../plugins/web3-source/gatsby-browser.js'),
      options: {"plugins":[],"token":"ABC123444555TOKENTOKEN"},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
